export default __webpack_public_path__ + "static/omid-bonyadian-92foQAl3lNc-unsplash-34652c16baf9fb7ae0868061f8b6475b.jpg";